import { render } from "./change-lesson-unit.vue?vue&type=template&id=67049a8c&scoped=true&ts=true"
import script from "./change-lesson-unit.ts?vue&type=script&lang=ts&external"
export * from "./change-lesson-unit.ts?vue&type=script&lang=ts&external"

import "./change-lesson-unit.scss?vue&type=style&index=0&id=67049a8c&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67049a8c"]])

export default __exports__